// Workaround: @rails/ujs checks jQuery.rails at module load time and throws
// if it's already set. Clear it before requiring to prevent the conflict.
if (typeof jQuery !== 'undefined') {
  delete jQuery.rails;
}

module.exports = require("@rails/ujs");
